import React, { useEffect, useState } from 'react';
import Send from '../../core/communication';
import QualityScreen from '../../screen/QualityScreen';
import { useScope } from "../SelectProjectCompanyContainer"

const QualityContainer = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false)
  const { scope, scopeType } = useScope()

  const loadData = async () => {
    setLoading(true)
    await Send.get(`/gcp/outlier/${scope?.id}`, `scopeType=${scopeType}`).then(setData)
    setLoading(false)
  }
  useEffect(() => {
    if(scope?.id){
      loadData()
    }
  }, [scope?.id])

  return <QualityScreen data={data} loading={loading} />;
}

export default QualityContainer;